export const SET_FONCTIONS = 'paye-bo/fonctions/SET_FONCTIONS'
export const SET_TAGS_FONCTIONS = 'paye-bo/fonctions/SET_TAGS_FONCTIONS'

const initialState = {
  fonctions: [],
  tagsFonction: {},
}

export default function fonctionModule(state = initialState, action) {
  switch (action.type) {
    case SET_FONCTIONS:
      return { ...state, fonctions: action.value }
    case SET_TAGS_FONCTIONS:
      return { ...state, tagsFonction: action.value }
    default:
      return state
  }
}
